// extracted by mini-css-extract-plugin
export default {"card":"CategoryCards_card__qBjyt"};